/*
  validate helper functions take in an input and return the following,

  [disableNext: bool, warningText: string]
 */

import showAPI from "../../../../api/shows";

export const validateCPM = (cpm, defaultCPM) => {
  if (cpm < 200) {
    return [true, "$2 is the minimum CPM"];
  }
  if (cpm > 10000) {
    return [true, "$100 is the maximum CPM"];
  }

  const low = Math.round((defaultCPM * 0.66) / 100) * 100;
  const high = Math.round((defaultCPM * 1.33) / 100) * 100;
  const recommended = `Recommended Range: $${low / 100}–$${high / 100}`;

  if (cpm < low) {
    return [false, `This CPM is low for your show size based on industry data. ${recommended}`];
  }

  if (cpm > high) {
    return [false, `This CPM is high for your show size based on industry data. ${recommended}`];
  }

  return [false, ""];
};

export const validateLink = (url, domain) => {
  const textContains = (haystack, needle) => {
    return haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1;
  };

  if (!url || (textContains(url, "https://") && textContains(url, domain))) {
    return [false, ""];
  }
  return [true, "Link should start with https:// and include " + domain];
};

export const validatePromoCode = async (showUUID, code) => {
  const isAlphaNumeric = /^[a-z0-9]+$/i.test(code);
  if (!isAlphaNumeric) {
    return [true, "Promo code should be alphanumeric and must not include spaces."];
  }

  const resp = await showAPI.validatePromoCode(showUUID, code);
  if (resp.status !== 200) {
    return [true, "Promo code is already in use, please try another one."];
  }

  return [false, ""];
};
